import React, { useState } from 'react';
import { Box, TextField, Button, Alert, Typography } from '@mui/material';
import Layout from '../../components/Layout/Layout';
import PageHeader from '../../components/Common/PageHeader';
import { changePasswordApi } from '../../api/auth';

export default function ChangePassword() {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_new_password: '' });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    setSuccess(false);
    try {
      await changePasswordApi(form);
      setSuccess(true);
      setForm({ current_password: '', new_password: '', confirm_new_password: '' });
    } catch (err) {
      setErrors(err.response?.data || {});
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Change Password">
      <PageHeader title="Change Password" />
      <Box sx={{ maxWidth: 450 }}>
        {success && <Alert severity="success" sx={{ mb: 2 }}>Password changed successfully.</Alert>}
        {errors.non_field_errors && <Alert severity="error" sx={{ mb: 2 }}>{errors.non_field_errors[0]}</Alert>}
        <Box component="form" onSubmit={handleSubmit}>
          <TextField fullWidth label="Current Password" type="password" value={form.current_password}
            onChange={set('current_password')} required sx={{ mb: 2 }}
            error={!!errors.current_password} helperText={errors.current_password?.[0]} />
          <TextField fullWidth label="New Password" type="password" value={form.new_password}
            onChange={set('new_password')} required sx={{ mb: 2 }}
            error={!!errors.new_password} helperText={errors.new_password?.[0]} />
          <TextField fullWidth label="Confirm New Password" type="password"
            value={form.confirm_new_password} onChange={set('confirm_new_password')} required
            sx={{ mb: 3 }} error={!!errors.confirm_new_password}
            helperText={errors.confirm_new_password?.[0]} />
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? 'Updating...' : 'Update Password'}
          </Button>
        </Box>
      </Box>
    </Layout>
  );
}
